import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import checkIcon from "../../assets/images/check.svg";
import greenCheck from "../../assets/images/green-check-circle.svg";
import alertIcon from "../../assets/images/alert-triangle.svg";
import {
  NavLink,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { motion } from "framer-motion";
import Faculties from "pages/Onboarding/Faculties";
import Leaders from "pages/Onboarding/Leaders";
import Teachers from "pages/Onboarding/Teachers";
import ChatBot from "pages/Onboarding/ChatBot";
import LF from "pages/Onboarding/LandingForm/LF";
import Preview from "pages/Onboarding/Preview";
import LinkYourAccounts from "pages/Onboarding/Step4/LinkYourAccounts";
import Occasions from "pages/Onboarding/Step4/Occasions";
import NewRecognitions from "pages/Onboarding/Recognition/NewRecognitions";
import NewTestimonials from "pages/Onboarding/Testimonials/NewTestimonials";
import NewBranding from "pages/Onboarding/Brochures/NewBranding";
import NewCampusInfo from "pages/Onboarding/CampusInfo/NewCampusInfo";
import Notifications from "pages/Onboarding/Step4/Notifications";
import ParentInsights from "pages/Onboarding/Step5/ParentInsights";
import AIManagmentHub from "pages/Onboarding/Step6/AIManagmentHub";
import AutoConnectHub from "pages/Onboarding/Step2/AutoConnectHub";
import { Img } from "components";
import ContentEngagement from "pages/Onboarding/Step4/ContentEngagement";
import ProcessComplete from "pages/Onboarding/ProcessComplete";
import NewAutoFeeHub from "pages/Onboarding/Step3/AutoFeeHub/NewAutoFeeHub";
import Template from "pages/Onboarding/Template";
import Stopwatch from "components/Stopwatch";
import Lottie from "lottie-react";
import RedDotAnimation from "assets/images/RedDotAnimation.json";
import WhatsApp from "pages/Onboarding/Whatsapp";
import TemplateMedia from "pages/Onboarding/TemplateMedia";
import { useGlobalState } from "state";
import classNames from "classnames";
import {
  PlayCircle, Monitor, HelpCircle, ArrowUpRight, X, PhoneCall, ChevronDown,
  Phone, ShieldCheck, Check, Calendar, ChevronLeft, ChevronRight
} from "lucide-react";

Modal.setAppElement("#root");

const DEV_MODE_DATA = {
  INSTITUTE_ID: 813,
  BRANCH_ID: 1,
  ACADEMIC_YEAR_ID: 1,
  DATABASE_NAME: "testonboard_0d609",
};

const SFR = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { instData } = useGlobalState();
  const [devToast, setDevToast] = useState(false);
  const [modalState, setModalState] = useState<{
    route: string;
    display: boolean;
  }>({
    route: "",
    display: false,
  });
  const [isSection1Complete, setIsSection1Complete] = useState(false);
  const [isSchoolFilled, setIsSchoolFilled] = useState(false);
  const [isFoundersFilled, setIsFoundersFilled] = useState(false);
  const [lastStep1Route, setLastStep1Route] = useState<string>("/onboarding/instituteInfo");
  const [showAppointmentPopup, setShowAppointmentPopup] = useState(false);
  const [showAppointmentConfirmedPopup, setShowAppointmentConfirmedPopup] = useState(false);
  const [contactNumber, setContactNumber] = useState('');
  const [timeSlot, setTimeSlot] = useState('');

  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpPhone, setHelpPhone] = useState('');
  const [helpCountryCode, setHelpCountryCode] = useState('+91');
  const [helpSelectedDate, setHelpSelectedDate] = useState<Date | null>(null);
  const [helpSelectedTime, setHelpSelectedTime] = useState('');
  const [helpCalendarOpen, setHelpCalendarOpen] = useState(false);
  const [helpTimeOpen, setHelpTimeOpen] = useState(false);
  const [helpCalendarDate, setHelpCalendarDate] = useState(new Date());
  const [helpBooked, setHelpBooked] = useState(false);

  const [stepProgress, setStepProgress] = useState<Record<string, number>>({
    instituteInfo: 0,
    aiManagementHub: 0
  });
  // State to track visited steps, persisting through reloads via sessionStorage
  const [visitedSteps, setVisitedSteps] = useState<string[]>(() => {
    try {
      return JSON.parse(sessionStorage.getItem("visitedSteps") || "[]");
    } catch {
      return [];
    }
  });
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "d") {
        e.preventDefault();
        sessionStorage.setItem("_DATA_", JSON.stringify(DEV_MODE_DATA));
        setDevToast(true);
        setTimeout(() => setDevToast(false), 3000);
        navigate("/onboarding/aiManagementHub");
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  const areBIDAndInsIdPresent = () => {
    return instData?.BRANCH_ID && instData?.INSTITUTE_ID;
  };

  const [formKey, setFormKey] = React.useState(Date.now());

  let instituteData = null;
  try {
    instituteData = JSON.parse(sessionStorage?.getItem("_DATA_") || "{}");
  } catch (err) { }

  const YOUR_WEBSITE_FORMS = [
    {
      label: "School Info",
      route: "/onboarding/instituteInfo",
      value: sessionStorage.getItem("Institute"),
      id: "Institute",
      required: false,
    },
    {
      label: "Founders/Leader info",
      route: "/onboarding/instituteInfo/founders",
      value: sessionStorage.getItem("founders"),
      id: "founders",
      required: false,
    },
  ];

  const SOCIAL_HUB_FORMS = [
    {
      label: "Link your accounts",
      route: "/onboarding/socialHubInfo",
      value: sessionStorage.getItem("socialHubInfo"),
    },
    {
      label: "Occasions",
      route: "/onboarding/socialHubInfo/occasions",
      value: sessionStorage.getItem("occasions"),
    },
    {
      label: "Content engagement",
      route: "/onboarding/socialHubInfo/content-engagement",
      value: sessionStorage.getItem("countentEngagement"),
    },
  ];

  const AUTO_FEE_HUB__FORMS = [
    {
      label: "Auto Fee Hub",
      route: "/onboarding/autoFeeHub",
      value: sessionStorage.getItem("autoFeeHub"),
      id: "autoFeeHub",
    },
  ];

  const AUTO_CONNECT_HUB__FORMS = [
    {
      label: "Auto Connect Hub",
      route: "/onboarding/autoConnectHub",
      value: sessionStorage.getItem("autoConnectHub"),
      id: "autoConnectHub",
    },
  ];

  const AI_MANAGMENT_HUB__FORMS = [
    {
      label: "AI Management Hub",
      route: "/onboarding/aiManagementHub",
      value: sessionStorage.getItem("aiManagementHub"),
      id: "aiManagementHub",
    },
  ];

  const PARENTAL_INSIGHTS = [
    {
      label: "Parental insights",
      route: "/onboarding/parentalInsights",
      value: sessionStorage.getItem("parentalInsights"),
      id: "parentalInsights",
    },
  ];

  const STEPS = [
    {
      label: "Your Website",
      options: YOUR_WEBSITE_FORMS,
      route: "/onboarding/instituteInfo",
      id: "instituteInfo",
      status: isSection1Complete || !!instituteData?.BRANCH_ID,
    },
    {
      label: "AI Management Hub",
      options: AI_MANAGMENT_HUB__FORMS,
      route: "/onboarding/aiManagementHub",
      id: "aiManagementHub",
      status: "",
    },
  ];

  function getStepObject(url) {
    const baseRoute = url?.split("/")?.slice(0, 3)?.join("/");
    return (
      STEPS?.find((step) => step?.route === baseRoute)?.options || ([] as any)
    );
  }

  useEffect(() => {
    const checkCompletion = () => {
      try {
        const instDataRaw = sessionStorage.getItem("Institute");
        let isInstituteFilled = false;
        let instituteProgress = 0;

        if (instDataRaw) {
          const parsedInst = instDataRaw.startsWith("{") ? JSON.parse(instDataRaw) : {};
          const basicFields = [
            parsedInst?.NAME, parsedInst?.EMAIL, parsedInst?.TOTAL_STUDENTS_COUNT,
            parsedInst?.Number_Of_Branches, parsedInst?.LOGO, parsedInst?.DOMAIN_NAME,
            parsedInst?.INSTITUTE_TYPE, parsedInst?.BOARD_TYPE, parsedInst?.FOUNDING_DATE,
            parsedInst?.GOOGLE_MAP_POSITION
          ];
          const arrayFields = [
            parsedInst?.INSTRUCTION_MEDIUM?.length > 0,
            parsedInst?.GRADE_LEVELS?.length > 0
          ];

          const totalFilled = basicFields.filter(Boolean).length + arrayFields.filter(Boolean).length;
          const totalRequired = 12;

          instituteProgress = (totalFilled / totalRequired) * 50;
          isInstituteFilled = totalFilled === totalRequired;
        }

        const foundersDataRaw = sessionStorage.getItem("founders");
        let hasAtLeastOneFounder = false;
        let foundersProgress = 0;

        if (foundersDataRaw) {
          const parsedFounders = JSON.parse(foundersDataRaw);
          const foundersArray = Array.isArray(parsedFounders) ? parsedFounders : parsedFounders?.founders || [];
          const validFounders = foundersArray.filter((item: any) => !!item?.INSTITUTE_LEADER_NAME);

          if (validFounders.length > 0) {
            hasAtLeastOneFounder = true;
            foundersProgress = 50;
          } else if (foundersArray.length > 0) {
            foundersProgress = 15;
          }
        }

        setIsSection1Complete(isInstituteFilled && hasAtLeastOneFounder);
        setIsSchoolFilled(isInstituteFilled);
        setIsFoundersFilled(hasAtLeastOneFounder);
        const finalStep1Progress = Math.min(instituteProgress + foundersProgress, 100);

        let step2Progress = 0;
        const aiHubDataRaw = sessionStorage.getItem("aiManagmentHub");
        const aiHubStage = sessionStorage.getItem("aiHubCurrentStage");

        // 1. If the stage is DONE, force 100% immediately (handles the short path)
        if (aiHubStage === 'DONE') {
          step2Progress = 100;
        } else {
          // 2. Otherwise, calculate progress based on populated data
          if (aiHubDataRaw) {
            const parsedAiHub = JSON.parse(aiHubDataRaw);
            const hasStudents = parsedAiHub?.STUDENT_DATA?.length > 0 ? 25 : 0;
            const hasParents = parsedAiHub?.PARENT_DATA?.length > 0 ? 25 : 0;
            const hasStaff = parsedAiHub?.STAFF_DATA?.length > 0 ? 25 : 0;
            const hasArrears = parsedAiHub?.FEE_ARREARS_DATA?.length > 0 ? 25 : 0;

            step2Progress = hasStudents + hasParents + hasStaff + hasArrears;
          }

         // 3. If no data is filled yet, fallback to the intermediate stage progression
          if (step2Progress === 0 && aiHubStage) {
            switch (aiHubStage) {
              case 'UPLOAD': step2Progress = 0; break;
              case 'AUTO_REVIEW': step2Progress = 16; break;
              case 'IDENTIFY': step2Progress = 33; break;
              case 'HEADER_CHECK': step2Progress = 50; break;
              case 'MAPPING': step2Progress = 66; break;
              case 'REVIEW': step2Progress = 83; break;
              // DONE is already handled at the top (100%)
            }
          }
        }

        const finalStep2Progress = Math.min(step2Progress, 100);

        setStepProgress({
          instituteInfo: finalStep1Progress,
          aiManagementHub: finalStep2Progress
        });

      } catch (error) {
        console.error("Error parsing session storage data", error);
      }
    };

    checkCompletion();
    window.addEventListener("formUpdated", checkCompletion);

    return () => {
      window.removeEventListener("formUpdated", checkCompletion);
    };
  }, [location.pathname]);

  useEffect(() => {
    const currentActiveId = STEPS.find((step) =>
      location.pathname.includes(step.id),
    )?.id;

    if (currentActiveId) {
      setVisitedSteps((prevSteps) => {
        if (!prevSteps.includes(currentActiveId)) {
          const updatedSteps = [...prevSteps, currentActiveId];
          sessionStorage.setItem("visitedSteps", JSON.stringify(updatedSteps));
          return updatedSteps;
        }
        return prevSteps;
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    const isExactOnboardingPath = ["/onboarding", "/onboarding/"].includes(location.pathname);
    if (isExactOnboardingPath) {
      navigate("/onboarding/instituteInfo", { replace: true });
    }
  }, [location.pathname, navigate]);

  const overallProgress = Math.round(
    ((stepProgress.instituteInfo || 0) + (stepProgress.aiManagementHub || 0)) / 2
  );

  const renderNavLinkClasses = (route?: string) => {
    const isActive = location?.pathname === route;
    return {
      value: isActive
        ? "relative text-[1.22vw] inline-block py-[0.44vw] text-blue-600 border-b-[0.22vw] border-transparent rounded-t-[0.44vw] active dark:text-blue-500 font-inter font-[500] after:content-[''] after:absolute after:left-0 after:-bottom-[0.22vw] after:w-full after:h-[0.22vw] after:bg-blue-600 after:rounded-[0.16vw]"
        : "relative text-[1.22vw] inline-block py-[0.44vw] px-[0.88vw] border-b-[0.22vw] border-transparent rounded-t-[0.44vw] hover:text-gray-600 dark:hover:text-gray-300 font-inter font-[500] after:content-[''] after:absolute after:left-0 after:-bottom-[0.22vw] after:w-full after:h-[0.22vw] after:bg-transparent hover:after:bg-gray-300 after:rounded-[0.16vw]", clickable: isActive,
    };
  };

  const resetFormData = () => {
    sessionStorage.removeItem(
      getStepObject(location?.pathname)?.find(
        (item) => item?.route === location?.pathname,
      )?.id,
    );
    setFormKey((formKey) => Date.now());
  };

  const handleNavigate = (preview?: boolean, link?: string) => {
    if (preview) {
      window.location.href = "/onboarding/instituteInfo/preview";
    } else if (link) {
      navigate(link);
    } else {
      const currentStepForms = getStepObject(location?.pathname);
      const currentFormIndex = currentStepForms?.findIndex(
        (item) => item?.route === location?.pathname,
      );

      const nextForm = currentStepForms?.[currentFormIndex + 1];

      if (nextForm) {
        navigate(nextForm.route);
      } else {
        const currentMajorStepIndex = STEPS.findIndex(
          (step) => step.options === currentStepForms,
        );
        const nextMajorStep = STEPS[currentMajorStepIndex + 1];

        if (nextMajorStep) {
          navigate(nextMajorStep.route);
        } else {
          navigate("/onboarding/onboarding-complete");
        }
      }
    }
  };

  function canNavigate(array, index, checkForTab = false) {
    if (checkForTab) {
      if (index === 0) return true;

      const previousItem = array?.[index - 1];
      return previousItem?.value ? true : false;
    } else {
      if (index === 0) return true;

      const previousItem = array?.[index - 1];
      return !!previousItem?.status ? true : false;
    }
  }

  const onRequestClose = () => {
    setModalState({ route: "", display: false });
  };

  const [isStep1Open, setIsStep1Open] = useState(true);
  const [isStep2Open, setIsStep2Open] = useState(false);
  const [activeSubsection, setActiveSubsection] = useState<string>('school');

  const handleSchoolInfoClick = () => {
    setActiveSubsection('school');
    navigate("/onboarding/instituteInfo");
  };

  const handleFoundersInfoClick = () => {
    setActiveSubsection('founders');
    navigate("/onboarding/instituteInfo/founders");
  };

  useEffect(() => {
    const path = location.pathname;

    if (path === "/onboarding/instituteInfo/founders") {
      setActiveSubsection("founders");
      setLastStep1Route(path); // <-- ADD THIS: Remembers you were on Founders
      setIsStep1Open(true);
    } else if (path === "/onboarding/instituteInfo") {
      setActiveSubsection("school");
      setLastStep1Route(path); // <-- ADD THIS: Remembers you were on School Info
      setIsStep1Open(true);
    } else if (path.includes("/onboarding/aiManagementHub")) {
      setActiveSubsection("");
     // setIsStep2Open(false);
    } else {
      setActiveSubsection("");
    }
  }, [location.pathname]);

  const handleAiManagementHubClick = () => {
    setIsStep2Open(true);
    navigate("/onboarding/aiManagementHub");
  };

  return (
    <div key={formKey} className="fixed inset-0 w-full h-full flex flex-row font-manrope text-gray-ob bg-[#FAF3F0] overflow-hidden">
      {devToast && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-2 bg-emerald-600 text-white px-5 py-3 rounded-xl shadow-2xl text-sm font-inter font-medium whitespace-nowrap">
          <span className="w-2 h-2 rounded-full bg-white shrink-0" />
          Dev mode active — INST: {DEV_MODE_DATA.INSTITUTE_ID} · BRANCH: {DEV_MODE_DATA.BRANCH_ID} · AY: {DEV_MODE_DATA.ACADEMIC_YEAR_ID} · DB: {DEV_MODE_DATA.DATABASE_NAME}
        </div>
      )}
      {/* SIDEBAR ON LEFT */}
      {![
        "/onboarding/onboarding-complete",
        "/onboarding/onboarding-whatsapp",
      ].includes(location?.pathname) && (
          <>
            <div className="block flex bg-[#FFFFFF] w-[18vw] border-r border-[#E2E0D9] h-full overflow-y-auto shrink-0 z-10">
              <div className=" w-full flex items-start justify-center bg-[#FFFFFF] ">
                <div className="w-full bg-[#FFFFFF]  flex flex-col relative h-[100%] overflow-hidden rounded-[0.22vw] ">
                  <div className="p-[1.5vw] flex-1 flex flex-col">
                    <h2 className="text-[2.6vh] font-montserrat font-[600] text-[#000] mb-[2vw] ">Setup Progress</h2>


                    {/* Step 1 */}
                    <div className="mb-[1.434vw] pl-[0.356vw]"> {/* Reduced margin and padding */}
                      <div
                        className={`flex items-center cursor-pointer select-none group ${isStep1Open ? 'mb-[1.077vw]' : ''}`}
                        onClick={() => {
                          if (!location.pathname.includes("/onboarding/instituteInfo")) {
                            setIsStep1Open(true);
                            navigate(lastStep1Route);
                          } else {
                            setIsStep1Open((prev) => !prev);
                          }
                        }}
                      >
                        {/* Step Circle - Reduced from 1.8vw/1.8vh to 1.62vw/1.62vh */}
                        <div className={`w-[2vw] h-[2vw] font-inter font-[500] rounded-full !text-[#fff] flex items-center justify-center text-[2vh] mr-[0.713vw] z-10 shadow-sm group-hover:scale-105 transition-transform ${isStep1Open ? 'bg-blue-600' : 'bg-[#ABB7C2]'}`}>
                          01
                        </div>
                        {/* Step Header Text - Reduced from 2.952vh to 2.657vh */}
                        <h3 className={`text-[2.43vh] font-roboto font-[500] transition-colors ${isStep1Open ? 'text-[#000] group-hover:text-blue-700' : 'text-[#ABB7C2] group-hover:text-slate-600'}`}>Your website</h3>
                      </div>

                      {isStep1Open && (
                        <div className="pl-[1.8vw] relative">
                          <div className={`absolute left-[2.1vw] top-[0.267vw] bottom-[0.267vw] w-[0.089vw] transition-colors duration-300 ${isSchoolFilled ? 'bg-[#374AF2]' : 'bg-[#ABB7C2]'}`}></div>
                          <div
                            className="flex items-center mb-[2.3vh] relative z-10 cursor-pointer group"
                            onClick={handleSchoolInfoClick}
                          >
                            {/* Subsection Dot */}
                            <div className="w-[0.713vw] h-[0.713vw] mr-[0.535vw]   flex items-center justify-center shrink-0">
                              {isSchoolFilled ? (
                                <div className="w-[0.7vw] h-[0.7vw] rounded-full bg-[#00BA00]  ring-[0.202vw] ring-[#fff]"></div>
                              ) : (
                                <div className={`w-[0.7vw] h-[0.7vw] rounded-full ring-[0.202vw] ring-[#fff]  transition-transform ${activeSubsection === 'school' ? 'bg-[#374AF2] ' : 'bg-[#ABB7C2]'}`}></div>
                              )}
                            </div>
                            {/* Subsection Text */}
                            <span className={`text-[1.993vh] font-inter font-[400] leading-none transition-colors ${activeSubsection === 'school' ? 'text-[#374AF2]' : 'text-[#ABB7C2] group-hover:text-slate-600'}`}>School Info</span>
                          </div>

                          <div
                            className="flex items-center relative z-10 cursor-pointer group"
                            onClick={handleFoundersInfoClick}
                          >
                            <div className="w-[0.713vw] h-[0.713vw] mr-[0.535vw]  flex items-center justify-center shrink-0">
                              {isFoundersFilled ? (
                                <div className="w-[0.7vw] h-[0.7vw] rounded-full bg-[#00BA00] ring-[0.202vw] ring-[#fff]"></div>
                              ) : (
                                <div className={`w-[0.7vw] h-[0.7vw] rounded-full   ring-[0.202vw] ring-[#fff] transition-transform ${activeSubsection === 'founders' ? 'bg-[#374AF2]' : 'bg-[#ABB7C2]'}`}></div>
                              )}
                            </div>
                            <span className={`text-[1.993vh] font-inter font-[400] leading-none transition-colors ${activeSubsection === 'founders' ? 'text-[#000]' : 'text-[#ABB7C2] group-hover:text-slate-600'}`}>Founders/Leader info</span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Step 2 */}
                    <div className="pl-[0.356vw]">
                      <div
                        className={`flex items-center cursor-pointer select-none group ${isStep2Open ? 'mb-[1.077vw]' : ''}`}
                        onClick={() => {
                          if (location.pathname.includes("/onboarding/aiManagementHub")) {
                            setIsStep2Open((prevIsOpen) => !prevIsOpen);
                          } else {
                            setIsStep2Open(true);
                            navigate("/onboarding/aiManagementHub");
                          }
                        }}
                      >
                        <div className={`w-[2vw] h-[2vw] font-inter font-[500] rounded-full !text-[#fff] flex items-center justify-center text-[2vh] mr-[0.713vw] z-10 shadow-sm group-hover:scale-105 transition-transform ${isStep2Open ? 'bg-blue-600' : 'bg-[#ABB7C2]'}`}>
                          02
                        </div>
                        <h3 className={`font-roboto font-[500] text-[2.22vh] transition-colors ${isStep2Open ? 'text-[#000] group-hover:text-blue-700' : 'text-[#ABB7C2]  group-hover:text-slate-600'}`}>
                          Data setup
                        </h3>
                      </div>

                      {isStep2Open && (() => {
                        const currentStage = sessionStorage.getItem("aiHubCurrentStage") || 'UPLOAD';
                        const stages = ['UPLOAD', 'AUTO_REVIEW', 'IDENTIFY', 'HEADER_CHECK', 'MAPPING', 'REVIEW', 'DONE'];
                        const renderStages = ['AUTO_REVIEW', 'IDENTIFY', 'HEADER_CHECK', 'MAPPING', 'REVIEW', 'DONE'];
                        const isAiHubRoute = location.pathname.includes("/onboarding/aiManagementHub");

                        return (
                          <div className="pl-[1.8vw] relative">
                            {renderStages.map((stageKey, index) => {
                              const isCompleted = stages.indexOf(currentStage) > stages.indexOf(stageKey) || currentStage === 'DONE';
                              const isActive = isAiHubRoute && currentStage === stageKey;

                              const labels: Record<string, string> = {
                                AUTO_REVIEW: 'Extraction review',
                                IDENTIFY: 'Identify',
                                HEADER_CHECK: 'Clean',
                                MAPPING: 'Map',
                                REVIEW: 'Review',
                                DONE: 'Done'
                              };

                              return (
                                <div key={stageKey} className="flex items-center relative z-10 mb-[2.3vh] cursor-pointer group">
                                  <div className="w-[0.713vw] h-[0.713vw] mr-[0.535vw] flex items-center justify-center shrink-0 relative">
                                    {index !== renderStages.length - 1 && (
                                      <div
                                        className={`absolute top-[0.356vw] left-1/2 -translate-x-1/2 w-[0.089vw] z-[-1] transition-colors duration-300 ${isCompleted ? 'bg-[#00c853]' : 'bg-[#ABB7C2]'}`}
                                        style={{ height: 'calc(100% + 2.3vh)' }}
                                      ></div>
                                    )}
                                    {isCompleted ? (
                                      <div className="w-[0.7vw] h-[0.7vw] rounded-full bg-[#00BA00] ring-[0.202vw] ring-[#fff]"></div>
                                    ) : (
                                      <div className={`w-[0.7vw] h-[0.7vw] rounded-full ring-[0.202vw] ring-[#fff] transition-all  ${isActive ? 'bg-[#3b5bdb] ' : 'bg-[#ABB7C2]'}`}></div>
                                    )}
                                  </div>
                                  <span className={`text-[1.993vh] font-inter font-[400] leading-none transition-colors ${isActive ? 'text-[#3b5bdb] font-[500]' : isCompleted ? 'text-[#000]' : 'text-[#ABB7C2] group-hover:text-slate-600'}`}>
                                    {labels[stageKey]}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })()}
                    </div>
                  </div>


                  {overallProgress === 100 ? (
                    <div className="flex items-center gap-[0.56vw] sm:gap-[0.21vw] w-[90%] mx-auto pb-[1.8vw]">
                      <div className="relative flex items-center justify-center w-[2.1vw] h-[2.1vw] sm:w-[0.7vw] sm:h-[0.7vw] shrink-0 bg-[#16A329] rounded-full">
                        <svg className="w-[1vw] h-[1vw] text-[#fff] relative top-[0.05vw]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>

                      <div className="flex flex-col justify-center flex-1 w-full">
                        <div className="flex items-baseline gap-[0.224vw] sm:gap-[0.084vw] mb-[0.168vw] sm:mb-[0.056vw]">
                          <span className="text-[0.84vw] sm:text-[0.28vw] font-bold text-[#222222] tracking-tight leading-none">
                            100%
                          </span>
                          <span className="text-[0.6vw] sm:text-[0.112vw] font-medium text-[#16A329] whitespace-nowrap">
                            Completed...
                          </span>
                        </div>

                        <div className="w-full h-[0.224vw] sm:h-[0.056vw] bg-[#E0E0E0] rounded-full overflow-hidden mb-[0.168vw] sm:mb-[0.056vw]">
                          <div className="h-full bg-[#16A329] rounded-full transition-all duration-500" style={{ width: '100%' }}></div>
                        </div>

                        <div className="text-[0.64vw] sm:text-[0.101vw] text-[#888888] font-medium whitespace-nowrap">
                          successfully completed...
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center gap-[0.56vw] sm:gap-[0.21vw] w-[90%] mx-auto pb-[1.8vw]">

                      <div className="relative flex items-center justify-center w-[2.1vw] h-[2.1vw] sm:w-[0.7vw] sm:h-[0.7vw] shrink-0">

                        <style>
                          {`
                              @keyframes custom-beat {
                                0% { transform: scale(1); opacity: 0.6; }
                                14% { transform: scale(1.3); opacity: 0.8; }
                                28% { transform: scale(1); opacity: 0.6; }
                                42% { transform: scale(1.3); opacity: 0.8; }
                                70%, 100% { transform: scale(1); opacity: 0.6; }
                              }
                            `}
                        </style>

                        <div className="absolute inset-0 rounded-full border-[0.175vw] sm:border-[0.056vw] border-[#0047D4]"></div>

                        <div className="absolute inset-[0.28vw] sm:inset-[0.084vw] rounded-full bg-[#A3C0FF] animate-[custom-beat_1.5s_ease-in-out_infinite]"></div>

                        <div className="absolute inset-[0.56vw] sm:inset-[0.175vw] rounded-full bg-[#3B5BFF]"></div>

                      </div>

                      <div className="flex flex-col justify-center flex-1 w-full">
                        <div className="flex items-baseline gap-[0.224vw] sm:gap-[0.084vw] mb-[0.168vw] sm:mb-[0.056vw]">
                          <span className="text-[0.84vw] sm:text-[0.28vw] font-bold text-[#222222] tracking-tight leading-none">
                            {overallProgress}%
                          </span>
                          <span className="text-[0.6vw] sm:text-[0.112vw] font-medium text-[#00B000] whitespace-nowrap">
                            Completed...
                          </span>
                        </div>

                        <div className="w-full h-[0.224vw] sm:h-[0.056vw] bg-[#E0E0E0] rounded-full overflow-hidden mb-[0.168vw] sm:mb-[0.056vw]">
                          <div className="h-full bg-[#3B5BFF] rounded-full transition-all duration-300" style={{ width: `${overallProgress}%` }}></div>
                        </div>

                        <div className="text-[0.64vw] sm:text-[0.101vw] text-[#888888] font-medium whitespace-nowrap">
                          Few steps left...
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
              <hr className="border-t border-[#C9C9C9] scale-y-50" />
            </div>
          </>
        )}

      {/* RIGHT COLUMN: NAV & ROUTES */}
      <div className="flex-1 flex flex-col h-full overflow-hidden bg-[#FAF3F0]">
        <nav className="flex w-full justify-between items-center h-[8vh] border-b border-[#E2E0D9] bg-[#FFFFFF] shadow-[0_1px_2px_rgba(0,0,0,0.03)] p-[0.88vw] shrink-0 z-10">
          <div className="flex w-full items-center gap-[0.88vw]">
            <p
              className="font-semibold text-[3vh] pl-[3vw]"
              style={{
                background: "linear-gradient(to right, #f97316, #d946ef)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Onboarding Setup
            </p>
          </div>
          <div className="flex gap-[1.5vw] justify-end items-center flex-shrink-0 pr-[1vw]">
            <button
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent("start-onboarding-tour"))}
              className="flex items-center gap-[0.4vw] font-manropeSB text-[1.9vh] text-[#1f2937] hover:text-black transition-colors"
            >
              Take a tour
              <PlayCircle className="w-[1vw] h-[1vw]" strokeWidth={1.5} />
            </button>
            <button
              type="button"
              className="flex items-center gap-[0.4vw] font-manropeSB text-[1.9vh] text-[#1f2937] hover:text-black transition-colors"
            >
              Quick demo
              <Monitor className="w-[1vw] h-[1vw]" strokeWidth={1.5} />
            </button>
            <button
              type="button"
              onClick={() => { setShowHelpModal(true); setHelpBooked(false); }}
              className="flex items-center gap-[0.4vw] font-manropeSB text-[1.9vh] text-[#1f2937] hover:text-black transition-colors"
            >
              Get help
              <HelpCircle className="w-[1vw] h-[1vw]" strokeWidth={1.5} />
            </button>
            <button
              onClick={() => window.open("https://soomuch.ai/explore", "_blank")}
              type="button"
              className="flex items-center gap-[0.4vw] px-[1vw] py-[0.6vw] font-manropeSB rounded-[0.4vw] text-[1.9vh] !text-[#ffffff] bg-[#2563EB] hover:bg-[#1d4ed8] transition-colors ml-[0.5vw]"
            >
              Live Demo
              <ArrowUpRight className="w-[1.2vw] h-[1.2vw] text-[#ffffff]" strokeWidth={2} />
            </button>
          </div>
        </nav>

        {/* ROUTES AREA */}
        <div className="w-full flex-1 flex gap-x-[0.88vw] gap-y-[0.88vw] p-0 overflow-hidden bg-[#FAF3F0]">
          <div
            className={`flex-1 rounded-[0.94vw] min-w-0 mt-[0.66vw] mr-[0.88vw] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] ${getStepObject(location?.pathname)?.length <= 1 ? "mt-[0.8vh]" : ""
              }`}
          >
            <div className=" px-[2.5vw]  py-[1.1vw]  ">
              <Routes>
                <Route path="/instituteInfo" element={<LF handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/founders" element={<Leaders handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/faculties" element={<Faculties handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/recognition" element={<NewRecognitions handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/testimonials" element={<NewTestimonials handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/branding" element={<NewBranding handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/teachers" element={<Teachers handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/chatbot" element={<ChatBot handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/campusinfo" element={<NewCampusInfo handleNavigate={handleNavigate} resetFormData={resetFormData} disableForm={undefined} />} />
                <Route path="/instituteInfo/preview" element={<Preview handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/template" element={<Template handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/instituteInfo/templateMedia" element={<TemplateMedia handleNavigate={handleNavigate} resetFormData={resetFormData} disableForm={undefined} />} />
                <Route path="/socialHubInfo" element={<LinkYourAccounts handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/socialHubInfo/occasions" element={<Occasions handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/socialHubInfo/notification" element={<Notifications handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/socialHubInfo/content-engagement" element={<ContentEngagement handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/autoFeeHub" element={<NewAutoFeeHub handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/autoConnectHub" element={<AutoConnectHub handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/aiManagementHub" element={<AIManagmentHub handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/parentalInsights" element={<ParentInsights handleNavigate={handleNavigate} resetFormData={resetFormData} />} />
                <Route path="/onboarding-complete" element={<ProcessComplete />} />
                <Route path="/onboarding-whatsapp" element={<WhatsApp />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>

      {showHelpModal && (() => {
        const TIMES = ['9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '2:00 PM', '2:30 PM', '3:00 PM', '4:00 PM'];
        const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
        const year = helpCalendarDate.getFullYear();
        const month = helpCalendarDate.getMonth();
        const firstDayOfMonth = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const today = new Date(); today.setHours(0, 0, 0, 0);

        const prevMonth = () => setHelpCalendarDate(new Date(year, month - 1, 1));
        const nextMonth = () => setHelpCalendarDate(new Date(year, month + 1, 1));

        const isSelected = (d: number) =>
          helpSelectedDate?.getFullYear() === year &&
          helpSelectedDate?.getMonth() === month &&
          helpSelectedDate?.getDate() === d;

        const isDisabled = (d: number) => new Date(year, month, d) < today;

        return (
          <div className="fixed inset-0 z-[9998] flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="rounded-2xl w-[420px] max-h-[90vh] overflow-y-auto font-inter" style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', position: 'relative', zIndex: 9999 }}>
              {helpBooked ? (
                <div className="p-8 flex flex-col items-center gap-4 text-center">
                  <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="w-7 h-7 text-green-600" strokeWidth={2.5} />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900">Booking confirmed!</h2>
                  <p className="text-sm text-gray-500">We'll call you at <span className="font-medium text-gray-800">{helpCountryCode} {helpPhone}</span> on <span className="font-medium text-gray-800">{helpSelectedDate?.toDateString()}</span> at <span className="font-medium text-gray-800">{helpSelectedTime}</span>.</p>
                  <button onClick={() => setShowHelpModal(false)} className="mt-2 px-6 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors">Done</button>
                </div>
              ) : (
                <>
                  <div className="px-6 pt-6 pb-4 border-b border-gray-100">
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="text-xs font-semibold tracking-widest text-blue-600 uppercase mb-1">Onboarding Support</p>
                        <h2 className="text-xl font-bold text-gray-900 leading-tight">Schedule a call with us</h2>
                        <p className="text-sm text-gray-500 mt-1">Our team will walk you through the setup.</p>
                      </div>
                      <button onClick={() => setShowHelpModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors mt-0.5">
                        <X className="w-5 h-5" />
                      </button>
                    </div>
                  </div>

                  <div className="px-6 py-4 flex flex-col gap-4">
                    <div>
                      <p className="text-xs font-medium text-gray-500 mb-1.5">Phone number</p>
                      <div className="flex gap-2 items-center">
                        <select
                          value={helpCountryCode}
                          onChange={e => setHelpCountryCode(e.target.value)}
                          style={{ width: '80px', flexShrink: 0, border: '1px solid #d1d5db', borderRadius: '8px', height: '44px', paddingLeft: '10px', paddingRight: '24px', fontSize: '14px', color: '#1f2937', backgroundColor: '#fff', outline: 'none', cursor: 'pointer' }}
                        >
                          <option value="+91">+91</option>
                          <option value="+1">+1</option>
                          <option value="+44">+44</option>
                          <option value="+61">+61</option>
                        </select>
                        <input
                          type="tel"
                          placeholder="Enter mobile number"
                          value={helpPhone}
                          onChange={e => setHelpPhone(e.target.value)}
                          style={{ flex: 1, border: '1px solid #d1d5db', borderRadius: '8px', height: '44px', paddingLeft: '12px', paddingRight: '12px', fontSize: '14px', color: '#1f2937', outline: 'none', backgroundColor: '#fff' }}
                        />
                      </div>
                    </div>

                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                      <button
                        type="button"
                        onClick={() => setHelpCalendarOpen(o => !o)}
                        className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex flex-col items-start">
                          <span className="text-sm font-medium text-gray-700">Select a date</span>
                          {helpSelectedDate && !helpCalendarOpen && (
                            <span className="text-xs text-blue-600 font-medium mt-0.5">
                              {MONTHS[helpSelectedDate.getMonth()]} {helpSelectedDate.getDate()}, {helpSelectedDate.getFullYear()}
                            </span>
                          )}
                        </div>
                        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${helpCalendarOpen ? 'rotate-180' : ''}`} />
                      </button>

                      {helpCalendarOpen && (
                        <div className="px-4 pb-4 border-t border-gray-100">
                          <div className="flex items-center justify-between py-3">
                            <span className="text-sm font-semibold text-gray-800">{MONTHS[month]} {year}</span>
                            <div className="flex gap-1">
                              <button type="button" onClick={prevMonth} className="p-1 rounded hover:bg-gray-100 transition-colors">
                                <ChevronLeft className="w-4 h-4 text-gray-500" />
                              </button>
                              <button type="button" onClick={nextMonth} className="p-1 rounded hover:bg-gray-100 transition-colors">
                                <ChevronRight className="w-4 h-4 text-gray-500" />
                              </button>
                            </div>
                          </div>
                          <div className="grid grid-cols-7 mb-1">
                            {DAYS.map(d => (
                              <div key={d} className="text-center text-xs font-medium text-gray-400 py-1">{d}</div>
                            ))}
                          </div>
                          <div className="grid grid-cols-7 gap-y-1">
                            {Array.from({ length: firstDayOfMonth }).map((_, i) => <div key={`e-${i}`} />)}
                            {Array.from({ length: daysInMonth }).map((_, i) => {
                              const d = i + 1;
                              const disabled = isDisabled(d);
                              const selected = isSelected(d);
                              return (
                                <button
                                  key={d}
                                  type="button"
                                  disabled={disabled}
                                  onClick={() => { setHelpSelectedDate(new Date(year, month, d)); setHelpCalendarOpen(false); }}
                                  className="mx-auto w-8 h-8 rounded-full text-sm flex items-center justify-center transition-colors"
                                  style={
                                    selected ? { backgroundColor: '#2563eb', color: '#ffffff', fontWeight: 600 } :
                                      disabled ? { color: '#d1d5db', cursor: 'not-allowed' } :
                                        { color: '#1f2937' }
                                  }
                                >
                                  {d}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                      <button
                        type="button"
                        onClick={() => setHelpTimeOpen(o => !o)}
                        className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex flex-col items-start">
                          <div className="flex items-baseline gap-1">
                            <span className="text-sm font-medium text-gray-700">Select a time</span>
                            <span className="text-xs text-gray-400">— all times in IST</span>
                          </div>
                          {helpSelectedTime && !helpTimeOpen && (
                            <span className="text-xs text-blue-600 font-medium mt-0.5">{helpSelectedTime}</span>
                          )}
                        </div>
                        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${helpTimeOpen ? 'rotate-180' : ''}`} />
                      </button>

                      {helpTimeOpen && (
                        <div className="px-4 pb-4 border-t border-gray-100 pt-3">
                          <div className="grid grid-cols-3 gap-2">
                            {TIMES.map(t => (
                              <button
                                key={t}
                                type="button"
                                onClick={() => { setHelpSelectedTime(t); setHelpTimeOpen(false); }}
                                style={helpSelectedTime === t
                                  ? { backgroundColor: '#2563eb', color: '#ffffff', border: '1px solid #2563eb', borderRadius: '8px', fontSize: '13px', fontWeight: 500, padding: '8px 12px' }
                                  : { backgroundColor: '#ffffff', color: '#374151', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px', padding: '8px 12px' }
                                }
                              >
                                {t}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>

                    {(!helpPhone || !helpSelectedDate || !helpSelectedTime) ? (
                      <div className="w-full py-3 rounded-xl text-sm font-semibold text-center cursor-not-allowed" style={{ backgroundColor: '#e5e7eb', color: '#9ca3af' }}>
                        Confirm booking
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={() => setHelpBooked(true)}
                        className="w-full py-3 bg-blue-600 text-white-A700 rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors"
                      >
                        Confirm booking
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })()}

      <Modal
        isOpen={modalState.display}
        onRequestClose={onRequestClose}
        className="max-w-[24.88vw] m-auto bg-[white] rounded-[1.33vw] p-[1.33vw] shadow-lg outline-none"
        overlayClassName="z-[1100] fixed inset-0 bg-[black] bg-opacity-40 flex justify-center items-start"
      >
        <div className="bg-white w-full p-[0.88vw]">
          <div className="text-center mb-[1.33vw]">
            <div className="w-[2.66vw] h-[2.66vw] bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-[0.88vw]">
              <Img src={alertIcon} alt="Alert Required" className="w-[1.33vw] h-[1.33vw]" />
            </div>
            <h2 className="text-[1.11vw] font-bold text-gray-900 mb-[0.44vw]">
              Action Required
            </h2>
          </div>

          <div className="text-center mb-[1.77vw]">
            <p className="text-gray-700 leading-relaxed text-[0.88vw]">
              Please complete{" "}
              <span
                className="font-semibold text-blue-600 cursor-pointer"
                onClick={() => {
                  setModalState({ route: "", display: false });
                  navigate("/onboarding/instituteInfo");
                }}
              >
                Step 1
              </span>{" "}
              first to set up your Website information before continuing.
            </p>
          </div>

          <div className="flex flex-row gap-[0.66vw] justify-center">
            <button
              onClick={() => {
                setModalState({ route: "", display: false });
                navigate("/onboarding/instituteInfo");
              }}
              className="px-[1.33vw] py-[0.66vw] text-[0.77vw] font-medium text-[#fff] bg-blue-600 rounded-[0.44vw] hover:bg-blue-700 active:bg-blue-800 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-200 shadow-sm"
            >
              Go to Step 1
            </button>
            <button
              onClick={() => {
                setModalState({ route: "", display: false });
                navigate(modalState.route);
              }}
              className="px-[1.33vw] py-[0.66vw] text-[0.77vw] font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-[0.44vw] hover:bg-gray-100 hover:border-gray-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              Continue Anyway
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SFR;